<div >
    <form [formGroup]="surveyForm" class="question">
        <div class="form-group mt-1">
            <textarea class="form-control" [formControlName]="question.title" rows="10"></textarea>
        </div>
    </form>
</div>